export const translateEN = {
  en: {
    validations: {
      required: "This field is mandatory",
      min: "Minimum number of characters is {min}",
      max: "Maximum number of characters is {max}",
      time: "Enter a valid time",
      email: "Enter a valid email address",
      sameAs: "Passwords must match",
      validName: "Enter the full name",
      validCPF: "Enter a valid CPF",
      validCNPJ: "Enter a valid CNPJ",
    },
    labels: {
      add: "Add {en}",
      edit: "Edit {en}",
      new: "New {en}",
      back: "Back {en}",
      cancel: "Cancel {en}",
      save: "Save {en}",
      continue: "Continue {en}",
      select: "Select {en}",
      apply: "Apply",
      delete: "Delete {en}",
      finalize: "Finalize {en}",
      generic: "{en}",
      yes: "Yes",
      no: "No",
    },
    users: {
      form: {
        add: "Add user",
        edit: "Edit user",
        name: "Full name",
        org: "Organization",
        birthdate: "Birthdate",
        type: "User type",
        roles: {
          adm: "Admin",
          teacher: "Teacher",
          std: "Student",
        },
        userTypes: {
          active: "Active",
          inactive: "Inactive",
          blocked: "Blocked",
        },
      },
    },
    course: {
      title: "Courses",
      create: "Add new course",
      search: "Search courses",
      tabs: {
        all: "All courses",
        published: "Published",
        notPublished: "Not published",
        approved: "Approved",
        repproved: "Reapproved",
        waiting: "Waiting",
        notListed: "Not listed",
      },
      form: {
        add: "Create new course",
        edit: "Edit course",
        subtitle: "General info",
        name: "Course name",
        thumb: "Add course thumbnail",
        categories: "Categories",
        description: "Description",
        duration: "Duração",
        hasCertificate: "Has certificate",
        types: {
          adaptive:
            "The adaptive course is based on graph structure, you have to create mandatory lesson plans as well as supplementary plans. The structure of the course is formed by chapters, learning objectives and objects.",
          traditional:
            "The traditional course is based on the linear structure. The structure of the course is formed by chapters and objects.",
          listed:
            "The course will appear for the student, if he has been enrolled.",
          nonListed:
            "The course will not be shown to the student, you will have to re-approve the course if you want to change this option.",
        },
      },
      empty: {
        courses: "You haven't added any courses yet, click 'Create a course'.",
        chapters:
          "The registered chapters and contents will be listed in this space. Click “Add Chapter” to get started",
        objectives: "",
        objects: "",
      },
    },
    studentCourse: {
      empty: {
        materialBeingWatch: {
          title: "No material selected",
          description:
            "Click on one of the unlocked chapters in the menu on the left to view the content.",
        },
      },
      errors: {
        video: `
        <p>Reload the page.</p>
        <h4>Oops! Unable to load the video. Check your connection.</h4>`,
        pdf: {
          title: "Reload the page",
          description:
            "Oops! Unable to load the PDF. Check your connection.",
        },
      },
    },
    chapters: {
      title: "Content course",
      add: "New chapter",
      edit: "Edit chapter",
      form: {
        name: "Chapter name",
        predecessor: "Inform previous chapter",
        description: "Description",
        date: "Start date (optional)",
      },
    },
    objectives: {
      titles: {
        info: "General information",
        materials: "Objects",
        lessonPlans: "Lesson plans",
        quiz: "Quiz",
        objectives: "Objectives",
      },
      inputs: {
        name: "Objective name",
        objective: "Objective",
        description: "Description",
        type: "Material type",
        title: "Title",
        predecessor: "Predecessor learning objective",
      },
    },
    objects: {
      add: "Add object",
      edit: "Edit object",
      plans: "Plans",
      withoutplan: "Without plan",
      essential: "Essential",
      complementary: "Complementary",
      type: {
        intro: "Introdution",
        motivation: "Motivation",
        dev: "Development",
        closure: "Closure",
      },
      inputs: {
        classification: "Classification",
        name: "Object name",
        predecessor: "Predecessor learning object",
        related: "Related content",
        file: "Upload file",
        select: "Select classification",
        time: "Object viewing time",
      },
      empty: {
        title: "No objects added",
        description:
          "The objects will be listed here. Click 'New Object' to load these items.",
        status: {
          waiting: "This material is in processing",
          fail: "Failure to process the learning object",
          waitingLabel: "Wait for the object to load, you will see it here.",
          failLabel: "Failed to upload object, please try uploading again.",
        },
      },
    },
    avatar: {
      info: "If you prefer, you can select one of the avatars below as your profile picture.",
    },
    password: {
      label:
        "An email with instructions on how to reset your password will be sent. If you can't find the email, check your junk or spam box. The email may take a few seconds to reach your inbox.",
    },
    skipModal: {
      title: "Next object?",
      subtitle:
        "You haven't finished watching, do you really want to skip ahead? If you go ahead, you may have questions when you take the quiz.",
      next: "Advance",
      finalize: "Cancel",
    },
    attention: {
      title: "Is everything okay, {user}?",
      subtitle:
        "We noticed that you weren't following the video, so we paused it. Do you want to go back to the video?",
      info: "If you want, you can disable attention detection on the splash screen 'Account'.",
      accept: "Return to video",
    },
    quiz: {
      title: "Final quiz",
      next: "Next",
      finalize: "Finalize",
      saving: "Saving",
      reply: "Reply answer",
      right: "Correct",
      wrong: "Wrong",
      timeout: {
        title: "Time's up!",
        info: "Unfortunately, the time to answer the quiz is over. Shall we see the final result and the correction of all issues?",
      },
      result: {
        title: "Quiz result",
        currentPercentage: "Percentage of correct",
        minPercentage: "Minimum percentage",
        duration: "Duration",
        empty: "No question has been answered",
        done: "Concluded",
        proceed: "Proceed",
        more: "More Materials",
        moreMaterialsQuiz:
          "See the correction of the questions and then the new content",
        good: "Congratulations!",
        fail: "It wasn't this time, but that's okay!",
        messageGood: "You passed the quiz and completed the Objective",
        messageGoodMoreMaterials:
          "There are still some complementary classes in this objective that you can see and acquire more knowledge, what do you want to do?",
        messageFail:
          "you did not answer the required number of questions correctly. Please see the correction below. Afterward, you will have some additional materials for you to review before attempting a new quiz.",
      },
      teacher: {
        info: "General info",
        questions: "Final quiz",
        add: "Add question",
        edit: "Edit question",
        list: "Question list",
        duration: "Total duration",
        total: "Total questions displayed by the student",
        empty:
          "There are still no registered questions. Click “Add Question” to get started",
      },
    },
    question: {
      info: "General question information",
      content: "Related Content",
      reference: "Material References",
      prompt: {
        title: "Statement",
        empty: "Enter the question statement here",
        openQuestion: "Check as open question",
        tooltip:
          "By checking this option, the student can answer this open question via chatbot.",
        items: {
          empty: "Enter the question statement here",
          description: {
            title: "Explanation about the item",
            empty: "Enter the explanation of the item here",
          },
        },
      },
    },
    stats: {
      course: {
        cards: {
          quiz: "Overall grade average",
          attention: "Number of detection alerts",
        },
        sidebar: {
          general: "General info",
          objectives: "Objectives",
          quiz: "Quiz",
          students: "Course students",
          map: "Contents map",
          attentionLogs: "Attention logs",
        },
        charts: {
          titles: {
            inProgress: "In progress",
            enabled: "Enabled",
            disabled: "Disabled",
            inactive: "Inactives",
            conclude: "Conclusives",
          },
          tooltips: {
            actives:
              "Enrolled students who watched at least 1 object in the last 7 days.",
            inactives:
              "Inactive for more than 7 days and not viewing any objects.",
            concluded: "Concluiu todos os quizzes de todos os objetivos.",
          },
        },
        students: {
          status: {
            inProgress: "In progress",
            active: "Active",
            inactive: "Inactive",
            done: "Done",
            approved: "Approved",
            failed: "Failed",
          },
        },
      },
      student: {
        sidebar: {
          general: "General info",
          objectives: "Objectives",
          quiz: "Quiz",
          students: "Course students",
          map: "Contents map",
        },
      },
      objectives: {
        sidebar: {
          general: "General info",
          draftsFeedbacks: "Written feedback",
          questions: "Questions",
          objects: "Objects",
          feedbacks: "Feedbacks",
        },
      },
    },
    crawler: {
      title: "Video search",
      placeholder: "Search keywords, terms...",
      indexWords: "Click to see keyword quotes in the video",
      words: {
        course: "Course: ",
        chapter: "Chapter: ",
        duration: "Duration: ",
      },
      empty: {
        title: "No research performed",
        description:
          "Use this page to search videos by keywords. Search for something like “Swift”, “Matrix”, among other terms.",
      },
    },
    chat: {
      hello: "Hello",
      help: "How can I assist you? Here you can:",
      start: `<div class='space-y-4'> 
                <ul class="list-disc ml-6"> 
                  <li> 
                    <p>Ask questions about course content;</p> 
                  </li> 
                  <li> 
                    <p>General questions about how the platform works.</p>
                  </li>
                </ul> 
                <p>
                  You can also speak through audio, just click the microphone button or start your sentence with <strong>"Help," "Assist me," or "I need help."</strong>
                </p>
              </div>`,
      reviewingContent: "How about reviewing the content?",
      reviewLearned: "Let's review what you have learned! Answer the question:",
      nextObjectWarning:
        "You are in the initial object, so it is not possible to go back to the previous one.",
      testLearned: "I want to test what I have learned!",
    },
    voice: {
      low: "Low",
      normal: "Normal",
      medium: "Medium",
      fast: "Fast",
    },
    csvImport: {
      errors:
        "Unable to import the file below. Check the following list lines for errors, correct the information and import a new document.",
      fileError: "Unable to import the selected file.",
      headers: {
        listError: "Error importing list",
        errorReport: "Bug report",
        loading: "Importing file...",
      },
    },
    organizations: {
      create: {
        buttons: {
          info: "Informations",
          course: "Courses",
          user: "Users",
        },
      },
    },
    blacklist: {
      empty: {
        title: "No keywords",
        description:
          "Upload a video or wait for the keywords for your videos that have already been added to load.",
      },
    },
    order: {
      header: "Material's list from {name}",
    },
    classes: {
      status: {
        enabled: "Active",
        disabled: "Disabled",
      },
      create: {
        buttons: {
          info: "Class information",
          select: "Select users",
        },
        inputs: {
          name: "Class name",
          initial: "Initial date",
          final: "Final date",
          select: "Select course",
        },
      },
    },
    homeStudent: {
      filters: {
        name: "Search for courses",
        classroom: {
          title: "Classroom ",
          placeholder: "Select classroom",
        },
        status: {
          title: "Conclusion status",
          placeholder: "Select status",
        },
      },
    },
    forum: {
      listForums: {
        title: "Forum Management",
      },
      listDenounces: {
        comments: {
          title: "Denounced comments",
          table: {
            columns: {
              author: "Comment author",
              denounces: "Denounces",
              status: "Status",
            },
          },
        },
        topics: {
          title: "Denounced topics",
          table: {
            columns: {
              title: "Topic title",
              author: "Topic author",
              denounces: "Denounces",
              status: "Status",
            },
          },
        },
        tableDenounces: {
          buttons: {
            toComments: "Comments reports",
            toTopics: "Topics reports",
          },
          paginatorText: "Showing {first}-{last} of {total} denounces",
          columns: {
            denounceAuthor: "Denounce author",
            dateOfDenounce: "Date of denounce",
            description: "Reason",
            status: "Status",
            actions: "Actions",
          },
        },
        dialog: {
          accept: {
            header: "Accept denounce?",
            headerMultiple: "Accept {selectedDenounces} denounce(s)?",
            topic:
              "By accepting the report(s), the topic will be deleted and will no longer be available to students. Once confirmed, the action cannot be undone.",
            comment:
              "By accepting the report(s), the comment will be deleted and will no longer be available to students. Once confirmed, the action cannot be undone.",
          },
          dismiss: {
            header: "Dismiss denounce?",
            headerMultiple: "Dismiss {selectedDenounces} denounce(s)?",
            topic:
              "By dismissing the report(s), the topic will continue to be available on the Forum for other users of the platform.",
            comment:
              "By dismissing the report(s), the comment will continue to be available on the Forum for other users of the platform.",
          },
        },
      },
      banner: {
        title: "Forum",
      },
      comment: {
        authorDeleted: "User",
      },
      topic: {
        details: {
          listComments: {
            title: "Comments",
          },
        },
        denounce: {
          title: "Report topic",
          labels: {
            description:
              "Thank you for helping keep our community safe and welcoming. Please select the reason for your report:",
          },
          buttons: {
            sendReport: "Send report",
            cancel: "Cancel",
          },
        },
        form: {
          title: "Create new topic",
          editTitle: "Edit topic",
          labels: {
            title: "Topic title",
            tag: "Associated chapter",
            description: "Description",
            image: "Select an image (optional)",
            imageRequirements:
              "Allowed formats: PNG, JPG, JPEG and GIF. Maximum size allowed is 10 MB.",
          },
          buttons: {
            imageSend: "Send",
            publish: "Publish",
            cancel: "Cancel",
          },
        },
        comment: {
          form: {
            title: "Edit comment",
            label: {
              comment: "Comment",
            },
            buttons: {
              cancel: "Cancel",
              publish: " Publish",
            },
          },
        },
      },
    },
  },
};
